<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right">
        <b-button variant="primary" @click="onBtnAddClicked">
          <feather-icon icon="PlusIcon" class="mr-25" />
          <span>เพิ่มสิทธิ์</span>
        </b-button>
      </b-col>

      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title" 
            :title="tab.title +'('+ departmentName +')'"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
        <commonTable
          ref="tableCommon"
          :mode="tab"
          @handleSend="getManageDetail"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-card>
    </b-overlay>
    <ModalAddRole
      ref="ModalAddRole"
      @handle-submit="onModalSubmit"
      :departmentId="departmentId"
      :departmentName="departmentName"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import commonTable from "./components/commonTableUser.vue";
import SearchFilter from "./components/SearchFilter.vue";
import * as departmentStore from "@/store/api/department/index.js";
import ModalAddRole from "./components/ModalAddRole.vue";
import { departmentName } from "@/auth/localStorageUtils";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    SearchFilter,
    ModalAddRole,
  },
  data() {
    return {
      tabs: [{ title: "จัดการสิทธิ์ผู้ใช้งาน", mode: "User" }],
      activeTab: ["User"],
      showOverlay: false,
      departmentId: null,
      departmentName: null,
      departmentObj: {},
      params: {},
    };
  },
  mounted() {
    const _this = this;
    const departmentId = this.$route.query.departmentId;
    this.departmentId = departmentId;

    departmentStore
      .getById(departmentId)
      .then(function(response) {
        // handle success
        console.log("then", response);
        _this.departmentObj = response.data.data;
        _this.$route.meta.breadcrumb[2].text = _this.departmentObj.name;
        _this.departmentName = _this.departmentObj.name;

        // Add a temporary query parameter.
        _this.$router.replace({
          query: {
            temp: Date.now(),
            departmentId: _this.$route.query.departmentId,
          },
        });
        // Remove the temporary query parameter.
        _this.$router.replace({
          query: {
            temp: undefined,
            departmentId: _this.$route.query.departmentId,
          },
        });
      })
      .catch(function(error) {
        // handle error
        console.log("error", error);
      })
      .then(function() {
        // always executed
        console.log("GET");
        _this.$emit("handleOverlay", false);
      });
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    getManageDetail(id) {
      // let routeData = this.$router.resolve({name: 'LawScreeningManage', query: { id:id } });
      // window.open(routeData.href, '_blank');
    },
    getManageGroup(id) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      if (this.activeTab[0] == "GroupProcess") {
        const routeData = this.$router.resolve({
          name: "ScreeningGroupManage",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      } else {
        //(this.activeTab[0]=='List' || this.activeTab[0]=='Group')
        const routeData = this.$router.resolve({
          name: "ScreeningManage",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      }
    },
    searchFilterSubmit(params) {
      params.departmentId = this.$route.query.departmentId;
      this.params = params;
      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnAddClicked() {
      this.$refs.ModalAddRole.$refs["modal-add-role"].show();
    },
    onModalSubmit() {
      this.searchFilterSubmit(this.params);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
